import { CURRENCY_SYMBOLS } from 'modules/purchase/constants'

export const getCurrencyLabel = (currency: string): string =>
  CURRENCY_SYMBOLS[currency] || currency.toUpperCase()
